import { ReactElement } from "react";
import "./ChatTypeIcon.css"
import { ChatType } from "src/app/chats-panel/~store/models/enums/ChatType";
import Person4Icon from '@mui/icons-material/Person4';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import { Tooltip } from "@mui/material";
import { getChatTypeName } from "../../helpers/chat-name-helper/ChatTypeHelper";

type ChatTypeIconProps = {
  chatType?: ChatType;
  className?: string;
  iconSize?: 'inherit' | 'large' | 'medium' | 'small';
  tooltipPlacement?: "right" | "bottom-end" | "bottom-start" | "bottom" | "left-end" | "left-start" | 
    "left" | "right-end" | "right-start" | "top-end" | "top-start" | "top" | undefined;
}

export default function ChatTypeIcon(props: ChatTypeIconProps) {
  const {chatType, className, iconSize, tooltipPlacement} = props;

  function getChatTypeIcon() : ReactElement<any, any> {
    switch (chatType) {
      case ChatType.Comment: return <CommentOutlinedIcon fontSize={iconSize ?? 'medium'}/>;
      case ChatType.Group: return <GroupsIcon fontSize={iconSize ?? 'medium'}/>;
      case ChatType.Mailing: return <MailOutlinedIcon fontSize={iconSize ?? 'medium'}/>;
      default: return <Person4Icon fontSize={iconSize ?? 'medium'}/>;
    }
  }

  return (
    <div className={'chat-type-icon-wrapper ' + (className ?? '')}>
      <Tooltip placement={tooltipPlacement} 
        title={<p className="icon-tooltip-text">{getChatTypeName(chatType)}</p>}
        disableInteractive>
            {getChatTypeIcon()}
      </Tooltip>
    </div>
  )
}